angular.module('shared').directive('waiverEzidebitBankAccountPaymentDetails', function() {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      walletDetails: '=',
      publicKey: '=',
      pageParams: '=',
      saveWaiver: '&'
    },
    template: require('templates/shared/waivers/payment_details/waiver_ezidebit_bank_account.html.slim'),
    controller: ["$scope", "$rootScope", "$timeout", "$document", "loadingAnimation", "EzidebitService", function($scope, $rootScope, $timeout, $document, loadingAnimation, EzidebitService) {
      var endpoint, getBankAccountDetail, init, initSaveCustomer, initUpdateCustomer, isCustomerExist, onError, onSaveSuccess, onUpdateSuccess, ref, ref1, signedWaiverWalletDetail;
      endpoint = $scope.waiver.ezidebit_public_url;
      $scope.transliterate = EzidebitService.transliterate;
      signedWaiverWalletDetail = $scope.waiver.signed_waiver_wallet_detail_attributes;
      isCustomerExist = signedWaiverWalletDetail.customer_ref && signedWaiverWalletDetail.active_on_ezidebit;
      $scope.customerReference = EzidebitService.getCustomerReference({
        gymId: ((ref = $rootScope.gym) != null ? ref.id : void 0) || window.DATA.gym_id,
        contactId: (ref1 = $scope.waiver.signed_waiver_contacts_attributes[0]) != null ? ref1.contact_id : void 0,
        context: 'SW'
      });
      initSaveCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'SaveCustomerAccount',
            submitButton: 'submitBankAccount',
            submitCallback: onSaveSuccess,
            submitError: onError,
            customerFirstName: 'firstName',
            customerLastName: 'lastName',
            accountName: 'accountName',
            accountBSB: 'bsb',
            accountNumber: 'accountNumber',
            customerEmail: 'customerEmail',
            customerMobile: 'customerMobile',
            customerReference: 'customerReference'
          };
          window.initEziDebit();
          return eziDebit.init($scope.publicKey, params, endpoint);
        });
      };
      initUpdateCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'ChangeCustomerPaymentInfo',
            submitButton: 'updateBankAccount',
            submitCallback: onUpdateSuccess,
            submitError: onError,
            accountName: 'accountName',
            accountBSB: 'bsb',
            accountNumber: 'accountNumber',
            customerRef: 'customerRef'
          };
          window.initEziDebit();
          return eziDebit.init($scope.publicKey, params, endpoint);
        });
      };
      init = function() {
        if (isCustomerExist) {
          return initUpdateCustomer();
        } else {
          return initSaveCustomer();
        }
      };
      $scope.$watch('publicKey', function(key) {
        if (key) {
          return init();
        }
      });
      onSaveSuccess = function(response) {
        $scope.walletDetails.error = void 0;
        $scope.waiver.signed_waiver_wallet_detail_attributes = angular.extend($scope.waiver.signed_waiver_wallet_detail_attributes, getBankAccountDetail(), {
          customer_ref: response.Data.CustomerRef
        });
        return $scope.saveWaiver();
      };
      onUpdateSuccess = function(response) {
        $scope.walletDetails.error = void 0;
        $scope.waiver.signed_waiver_wallet_detail_attributes = angular.extend($scope.waiver.signed_waiver_wallet_detail_attributes, getBankAccountDetail());
        return $scope.saveWaiver();
      };
      getBankAccountDetail = function() {
        return {
          payment_method: 'bank_account',
          payment_provider: 'ezidebit',
          last4: $scope.walletDetails.accountNumber.substr(-4),
          bsb: $scope.walletDetails.bsb,
          full_name: $scope.walletDetails.accountName,
          exp_month: void 0,
          exp_year: void 0
        };
      };
      onError = function(error) {
        return $timeout(function() {
          $scope.pageParams.isLoading = false;
          loadingAnimation.hide();
          $scope.walletDetails.error = error;
          return $document.scrollToElementAnimated(angular.element('#walletDetails'));
        });
      };
      return $scope.onBsbChange = function() {
        var ref2;
        return $scope.walletDetails.bsb = (ref2 = $scope.walletDetails.bsb) != null ? ref2.replace(/[^0-9]/g, '') : void 0;
      };
    }]
  };
});
